import {useRef,useMemo} from "react";
import {useLocation} from "react-router-dom";
import COMPONENT_MAP from '../Repository/Components.js';

const SKUDetailMultipacks=({parentId,application,userData})=>{
    const list_name='sku_multipacks';
    const executeQuery=useRef(true);
    const location=useLocation();
    const navigateOnNew={route:'/sku/new/',args:{state:{from:location.pathname,context:{
        parent_name:'SKU',
        parent_field_name:'parent_sku_id',
        parent_field_value:parentId
    }}}};

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'SKU'}
                entityParams={['parent_sku_id='+parentId,'_context='+['parent_name=SKU'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'SKUDetailMultipacks.js'}
                getRowClassName={(params)=>
                    (params.row.status&&application.globalData.list_of_values_reverse.Sku_Status[params.row.status]==='LOGISTICS_INTEGRATION_ERROR')?'highlight-row':''
                    //['',undefined,0,null].includes(params.row.quarantined_balance)?'':'highlight-row'
                }
                dataGridSx={{
                    "& .highlight-row":{
                        backgroundColor:"#ffe6f0 !important",
                        color: "black",
                    }
                }}
                navigateOnNew={navigateOnNew}
                initialState={{}}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                parentContext={{parent_field_name:'parent_sku_id',parent_field_value:null,parent_name:'SKU'}}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default SKUDetailMultipacks;